<template>
	<!-- <f7-page class="" id="inbox"> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">

  		<f7-searchbar class="search"
  			cancel-link="Cancel"
  			search-list="#search-list"
  			@searchbar:search="onSearch"
  			@searchbar:enable="onEnable"
  			@searchbar:disable="onDisable"
  			@searchbar:clear="onClear">
  		</f7-searchbar>
  		<div class="layoutSubtitle"/>
  		<f7-list class="searchbar-not-found">
        <f7-list-item title="Nothing found"></f7-list-item>
      </f7-list>
  		<f7-list class="searchbar-found" id="search-list" sortable>
  			<cm-accounts-list v-bind:accounts="accountsItems" :filterBy="filterBy"></cm-accounts-list>
      </f7-list>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import CMAccountsList from './CMMainPage/CMAccountsList.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

export default {
  name: 'AccountsListPage',
  components: {
    'cm-accounts-list': CMAccountsList,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      filterBy: ''
    }
  },
  created () {
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage

    /* Turn off all buses events */
    // this.$bus.$off('inbox-filtered')
    this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-cache-service')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    // this.$bus.$off('refresh-cache-attachments-view')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
  },
  beforeDestroy () {

  },
  computed: {
    accountsItems: function () {
      return this.$engine.accounts.get()
    }
  },
  methods: {
    onSearch: function (query, found) {
      this.filterBy = query
    },
    onClear: function (event) {
      this.filterBy = ''
    },
    onEnable: function (event) {

    },
    onDisable: function (event) {

    },
    OpenFormsPage () {
      const that = this
      that.$f7.popup('.forms-page')
    }
  }
}
</script>
